/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { IVT_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { IvtPage } from "@/features/processing/components/ivt-page";

export const Route = createFileRoute("/_app/packaging/ivt/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(IVT_FORM))
      throw redirect({ to: "/packaging/ivt" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <IvtPage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
